module.exports = __webpack_public_path__ + "static/product-page-short-description-fd27829163f39f036f68c996880ac446.jpg";